<template> </template>
<script>
import request from "@/lib/axios";
export default {
  data() {
    return {};
  },
  created() {
    this.verification();
  },
  methods: {
    /**
     * [获取URL中的参数名及参数值的集合]
     * @return {[string]}       [参数集合]
     */
    getRequest() {
      var url = location.href; //获取url
      // console.log(url);
      url = "?" + url.split("?")[1]; //获取url中"?"符后的字串
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },

    /** 获取token */
    verification() {
      if (sessionStorage.getItem("token")) {
        this.$router.push({ path: "/" });
      } else {
        let params = this.getRequest();
        if (params.vin) {
          var vin = params.vin;
          delete params.vin;
        }
        if (params.symbol) {
          var symbol = params.symbol;
          delete params.symbol;
        }
        /* this.axios({
          method: "post",
          baseURL: "/login",
          url: "/getToken",
          params
        }).then(res => { */
        request({
          method: "post",
          baseURL: "/login",
          url: "/getToken",
          params
        }).then(res => {
          if (res.data.status == "0") {
            this.$store.commit("changeLonginToken", res.data.data);
            if (vin) {
              this.$router.push({
                path: "/catalog",
                query: { vin: vin }
              });
            } else if (symbol) {
              this.$router.push({
                path: "/catalog",
                query: { symbol: symbol }
              });
            } else {
              this.$router.push("/");
            }
          } else {
            this.$confirm("还未登录，请先登录", "提示", {
              confirmButtonText: "确定",
              type: "error"
            })
              .then(() => {
                window.open(
                  "https://www.apbenben.com/login/loginPage",
                  "_blank"
                );
              })
              .catch(() => {});
          }
        });
      }
    }
  }
};
</script>
<style scoped></style>
